import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { BOOKING_MAIN_URL, OPEN_BOOKING_15MIN_EVENT } from "@/hooks/use-cal";

const Booking15Modal = () => {
  const [open, setOpen] = useState(false);
  const [instance, setInstance] = useState(0);

  useEffect(() => {
    const onOpen = () => {
      setInstance((current) => current + 1);
      setOpen(true);
    };
    window.addEventListener(OPEN_BOOKING_15MIN_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_BOOKING_15MIN_EVENT, onOpen);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    if (open) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  // Préchargement pour une ouverture quasi instantanée
  useEffect(() => {
    const add = (rel: string, href: string) => {
      const link = document.createElement("link");
      link.rel = rel;
      link.href = href;
      if (rel === "preconnect") link.crossOrigin = "";
      document.head.appendChild(link);
    };
    add("preconnect", "https://api.leadconnectorhq.com");
    add("prefetch", BOOKING_MAIN_URL);
  }, []);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-0 backdrop-blur-sm sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="Réserver un appel de 15 minutes"
      onClick={() => setOpen(false)}
    >
      <div
        className="relative w-full max-w-5xl overflow-hidden bg-background sm:rounded-2xl sm:border sm:border-border"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label="Fermer"
          className="absolute right-3 top-3 z-20 grid h-9 w-9 place-items-center rounded-full border border-border bg-background/90 text-foreground transition-colors hover:bg-foreground/10"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>

        <div className="h-[min(712px,100dvh)] overflow-hidden bg-background sm:h-[min(920px,92dvh)]">
          <iframe
            key={instance}
            src={BOOKING_MAIN_URL}
            title="Réserver un appel de 15 minutes"
            className="block h-[712px] w-full border-0 bg-background sm:-mt-16 sm:h-[calc(min(920px,92dvh)+64px)]"
            allow="payment"
            scrolling="yes"
            loading="eager"
          />
        </div>

      </div>
    </div>
  );
};

export default Booking15Modal;
